import type { LucideIcon } from 'lucide-react';
import { Card, CardContent } from './card';

type EmptyStateProps = {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
};

export default function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <Card className="border-dashed bg-muted/30">
      <CardContent className="flex flex-col items-center px-6 py-10 text-center">
        {Icon && (
          <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-muted">
            <Icon className="h-5 w-5 text-muted-foreground" strokeWidth={1.5} />
          </div>
        )}
        <p className="font-medium text-foreground">{title}</p>
        {description && <p className="mt-1 max-w-xs text-sm text-muted-foreground">{description}</p>}
        {action && <div className="mt-4">{action}</div>}
      </CardContent>
    </Card>
  );
}
